<template>
  <v-dialog v-model="dialog" width="400">
    <v-card>
      <v-container>
        <template v-if="item">
          <v-row>
            <v-col cols="6">
              운전자
            </v-col>
            <v-col>
              {{ item.driver }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              급가속
            </v-col>
            <v-col>
              <span>{{item.smartscoreDetails.rapidAcceleration.count}} 회</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              급제동
            </v-col>
            <v-col>
              <span>{{item.smartscoreDetails.rapidDeceleration.count}} 회</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              급진로변경
            </v-col>
            <v-col>
              <span>{{item.smartscoreDetails.rapidChangeRoute.count}} 회</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              급회전
            </v-col>
            <v-col>
              <span>{{item.smartscoreDetails.rapidTurn.count}} 회</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              평균
            </v-col>
            <v-col>
              {{ item.smartscore }}
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row class="fill-height">
            <v-col cols="12" class="d-flex align-center justify-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    show () {
      this.dialog = true
    }
  }
}
</script>
